/*
 * affiliate-tracking.js — PickleBuddy
 *
 * Fires an "affiliate_click" event whenever a visitor clicks a link that leaves
 * the store for one of our affiliate partners. This is how we attribute which
 * PAGE and which BRAND actually drive clicks (and therefore commissions) — the
 * one piece of attribution Shopify's built-in analytics cannot see.
 *
 * It does NOT touch the link URLs themselves (the partner's ?snowball= / ?sca_ref=
 * / /discount/ codes that carry our commission attribution are left untouched).
 *
 * The event is dispatched to every analytics sink that might be present, so it
 * works no matter how GA4 was installed:
 *   1. window.gtag(...)             — GA4 installed via a theme gtag snippet
 *   2. window.dataLayer.push(...)   — Google Tag Manager
 *   3. Shopify.analytics.publish()  — Shopify Customer Events (the usual case when
 *                                     GA4 is connected via the Google & YouTube
 *                                     channel). A Custom Pixel can subscribe to the
 *                                     'affiliate_click' event and forward it to GA4.
 *
 * To capture it in GA4 when GA4 is connected via the Google channel, add a Custom
 * Pixel in Shopify admin (Settings → Customer events → Add custom pixel):
 *
 *     analytics.subscribe("affiliate_click", (event) => {
 *       gtag("event", "affiliate_click", event.customData);
 *     });
 */
(function () {
  'use strict';

  // host (lowercased, no leading www.) -> brand label
  var BRANDS = {
    'rpmpb.com': 'RPM',
    'crbnpickleball.com': 'CRBN',
    'luzzpickleball.com': 'Luzz',
    'dillcrew.com': 'DillCrew',
    'pb5star.com': 'PB5star',
    '11six24.com': '11Six24',
    '808pickle.com': '808 Pickle',
    'fridaypickle.com': 'Friday',
    'kitchenblockers.com': 'Kitchen Blockers',
    'hesacore.com': 'Hesacore',
    'shop.hesacore.com': 'Hesacore',
    'topspinpro.com': 'TopspinPro',
    'vaticpro.com': 'Vatic Pro',
    'advtennis.pro': 'ADV',
    'getadv.com': 'ADV',
    'jigsawhealth.com': 'Jigsaw Health',
    'stackathletics.com': 'Stack Athletics',
    'udrippin.com': 'Udrippin',
    'choruspickleball.com': 'Chorus',
    'shrsl.com': 'ShareASale',
    'skool.com': 'Twoey Nation'
  };

  // Hosts that belong to us / the platform — never counted as affiliate clicks.
  var INTERNAL = /(^|\.)(picklebuddy\.(shop|app)|myshopify\.com|shopify\.com|klaviyo\.com)$/i;

  function normalizeHost(host) {
    return (host || '').toLowerCase().replace(/^www\./, '');
  }

  function brandFor(host) {
    var h = normalizeHost(host);
    if (BRANDS[h]) return BRANDS[h];
    // Fallback: match a known brand host as a suffix (covers subdomains), else use the bare host.
    for (var key in BRANDS) {
      if (BRANDS.hasOwnProperty(key) && (h === key || h.indexOf('.' + key) === h.length - key.length - 1)) {
        return BRANDS[key];
      }
    }
    return h; // unknown partner — still record the click under its hostname
  }

  function isAffiliate(host) {
    var h = normalizeHost(host);
    if (!h) return false;
    if (INTERNAL.test(h)) return false;
    return true; // any external, non-platform host counts as an affiliate/outbound click
  }

  function fire(payload) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'affiliate_click', payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'affiliate_click' }, payload));
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('affiliate_click', payload);
      }
    } catch (e) {}
  }

  document.addEventListener(
    'click',
    function (evt) {
      var link = evt.target && evt.target.closest ? evt.target.closest('a[href]') : null;
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (e) {
        return;
      }
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
      if (!isAffiliate(url.host)) return;

      fire({
        brand: brandFor(url.host),
        link_url: url.href,
        link_domain: normalizeHost(url.host),
        page_path: window.location.pathname,
        page_location: window.location.href
      });
    },
    true // capture phase: fires even if the link opens in a new tab / navigates away
  );
})();
